export const environment = {
    production: true,
    apiUrl: 'https://eprint.ink',
    googleClientId: '498567213397-8u19ub190e02m0kmg7oucjpc8k1knrsl.apps.googleusercontent.com'
};
